// api/adminApi.js - Yönetici API istekleri (Durum ve Yöntem yönetimi)
import axios from 'axios';
import { getAuthHeader } from '../utils/authUtils';
import apiClient from './apiClient';

// Göreceli API URL'ini kullan
const API_URL = '/api';

// Axios instance oluştur
const adminApi = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// İstek interceptor'ü - her istekte token ekle
adminApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Yanıt interceptor'ü - hata işleme
adminApi.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const message = 
      error.response?.data?.message || 
      error.message || 
      'Bir hata oluştu';
    
    // 401 Unauthorized - token süresi doldu vs.
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    
    return Promise.reject(new Error(message));
  }
);

// ========== DURUM YÖNETİMİ API İSTEKLERİ ==========

// Tüm durumları getir
export const getStatuses = async () => {
  try {
    return await adminApi.get('/statuses');
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Durumlar yüklenirken bir hata oluştu'
    );
  }
};

// Belirli bir durumu getir
export const getStatusById = async (id) => {
  try {
    return await adminApi.get(`/statuses/${id}`);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Durum bilgileri alınırken bir hata oluştu'
    );
  }
};

// Yeni durum oluştur
export const createStatus = async (statusData) => {
  try {
    return await adminApi.post('/statuses', statusData);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Durum oluşturulurken bir hata oluştu'
    );
  }
};

// Durum güncelle
export const updateStatus = async (id, statusData) => {
  try {
    return await adminApi.put(`/statuses/${id}`, statusData);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Durum güncellenirken bir hata oluştu'
    );
  }
};

// Durum sil
export const deleteStatus = async (id) => {
  try {
    return await adminApi.delete(`/statuses/${id}`);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Durum silinirken bir hata oluştu'
    );
  }
};

// ========== ÖDEME YÖNTEMİ YÖNETİMİ API İSTEKLERİ ==========

// Tüm ödeme yöntemlerini getir
export const getMethods = async () => {
  try {
    return await adminApi.get('/methods');
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Ödeme yöntemleri yüklenirken bir hata oluştu'
    );
  }
};

// Belirli bir ödeme yöntemini getir
export const getMethodById = async (id) => {
  try {
    return await adminApi.get(`/methods/${id}`);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Ödeme yöntemi bilgileri alınırken bir hata oluştu'
    );
  }
};

// Yeni ödeme yöntemi oluştur
export const createMethod = async (methodData) => {
  try {
    return await adminApi.post('/methods', methodData);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Ödeme yöntemi oluşturulurken bir hata oluştu'
    );
  }
};

// Ödeme yöntemi güncelle
export const updateMethod = async (id, methodData) => {
  try {
    return await adminApi.put(`/methods/${id}`, methodData);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Ödeme yöntemi güncellenirken bir hata oluştu'
    );
  }
};

// Ödeme yöntemi sil
export const deleteMethod = async (id) => {
  try {
    return await adminApi.delete(`/methods/${id}`);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'Ödeme yöntemi silinirken bir hata oluştu'
    );
  }
};

// ========== İADE SEBEBİ YÖNETİMİ API İSTEKLERİ ==========

// Tüm iade sebeplerini getir
export const getReasons = async () => {
  try {
    return await adminApi.get('/reasons');
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'İade sebepleri yüklenirken bir hata oluştu'
    );
  }
};

// Belirli bir iade sebebini getir
export const getReasonById = async (id) => {
  try {
    return await adminApi.get(`/reasons/${id}`);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'İade sebebi bilgileri alınırken bir hata oluştu'
    );
  }
};

// Yeni iade sebebi oluştur
export const createReason = async (reasonData) => {
  try {
    return await adminApi.post('/reasons', reasonData);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'İade sebebi oluşturulurken bir hata oluştu'
    );
  }
};

// İade sebebi güncelle
export const updateReason = async (id, reasonData) => {
  try {
    return await adminApi.put(`/reasons/${id}`, reasonData);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'İade sebebi güncellenirken bir hata oluştu'
    );
  }
};

// İade sebebi sil
export const deleteReason = async (id) => {
  try {
    return await adminApi.delete(`/reasons/${id}`);
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'İade sebebi silinirken bir hata oluştu'
    );
  }
};

// Dashboard İstatistikleri
export const getAdminStats = async () => {
  try {
    return await adminApi.get('/admin/stats');
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 
      'İstatistikler alınırken bir hata oluştu'
    );
  }
};

export default adminApi;